export const PageTitle = "That IT Guy";
export const PageSubTitle = "Personal Tech Blog";
// if screen goes smaller than this it will convert the other small view
export const minTabletSize = "769px";

// visible part of all the content
export const maxWidth = "750px";
export const width = "80vw";

// default animation delays
export const transitionAnimationStyle = "all 0.35s ease-in-out";

// debugging variables
export const showDebugBorders = false;

export const themes = {
  white: {
    mainGrey: "#ecececc0",
    mainWhite: "rgb(255, 255, 255)",
    mainBlack: "rgb(25, 25, 25)",
    darkGrey: "#8e8e8e",
  },
  dark: {
    mainGrey: "#8e8e8e",
    mainWhite: "rgb(25, 25, 25)",
    mainBlack: "rgb(255, 255, 255)",
    darkGrey: "#ecececc0",
  },
};

export const borderRadius = "8px";

export const fonts =
  "https://fonts.googleapis.com/css2?family=Comic+Neue&display=swap";
